import React from "react";
import { default as MatCachedIcon } from "@material-ui/icons/Cached";

export const CachedIcon = () => <MatCachedIcon />;
